import Vue from 'vue';
import Notifications from 'vue-notification';

/*
or for SSR:
import Notifications from 'vue-notification/dist/ssr.js'
*/

Vue.use(Notifications);
